import React, { useState } from "react";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Carousel } from "react-responsive-carousel";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import CircularProgress from "@material-ui/core/CircularProgress";

import Header from "../../../components/molecules/Header";
import useStyles from "./style";

function Detail({ open, data, handleClose }) {
  const classes = useStyles();
  const theme = useTheme();
  const matches1 = useMediaQuery(theme.breakpoints.up("705"));
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const claimVoucher = async () => {
    setLoading(true);
    try {
      const func = firefunctions.httpsCallable("inpoin-claimVoucher");
      const datas = {
        PromoCode: data?.PromoCode,
      };
      const res = await func(datas);
      enqueueSnackbar(res?.data?.message, { variant: "success" });
      handleClose();
      setLoading(false);
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="max-width-dialog-title"
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <Header title={data.name} type="with-title" onClick={handleClose} />
      <DialogContent dividers style={{padding:10}}>
        <div>
          <div>
            <Carousel
              className={classes.carousel}
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showIndicators={false}
              showThumbs={false}
              autoPlay={false}
            >
              <img
                src={data.headerImage}
                alt={data.name}
                style={{
                  objectFit: "contain",
                  width: 360,
                  height: 360,
                  margin: "0 auto",
                }}
              />
            </Carousel>
          </div>
        </div>
        <div>
          <div className={classes.descHead}>
            <b>Deskripsi Produk</b>
          </div>
          <div className={classes.descBody}>{data?.description}</div>
        </div>
        <div className={classes.boxButton}>
          <div className={classes.buttonSelect}>
            <h2
              style={{
                fontFamily: "revert",
                color: "#C9C5C5",
                fontSize: matches1 ? 16 : 15,
              }}
              onClick={handleClose}
            >
              Batalkan
            </h2>
          </div>
          <div
            className={
              loading
                ? classes.buttonSelect
                : data.availableVoucher > 0
                ? classes.buttonSelect1
                : classes.buttonSelect
            }
            onClick={data.availableVoucher > 0 ? claimVoucher : handleClose}
          >
            <h2
              style={{
                fontFamily: "revert",
                color: data.availableVoucher > 0 ? "white" : "#C9C5C5",
                fontSize: matches1 ? 16 : 15,
              }}
            >
              {loading ? (
                <CircularProgress size={20} />
              ) : data.availableVoucher > 0 ? (
                "Tukar Coin"
              ) : (
                "Habis"
              )}
            </h2>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Detail;
